import React, { useState, useEffect } from "react";
import { useAuth } from "../../../../hooks/useAuth";
import ChargeRequest from "./ChargeRequest";
import ChargeHistory from "./ChargeHistory";
import RefundRequest from "./RefundRequest";
import RefundHistory from "./RefundHistory";
import UsageHistory from "./UsageHistory";
import TabNavigation from "../../../../components/common/tabNavigation";
import "./Deposit.css";

const Deposit = ({ initialTab = "chargeRequest" }) => {
  const { user } = useAuth();
  const [activeSubTab, setActiveSubTab] = useState(initialTab);

  const getAllTabs = () => [
    { id: "chargeRequest", label: "충전신청" },
    { id: "chargeHistory", label: "충전내역" },
    { id: "refundRequest", label: "환불신청" },
    { id: "refundHistory", label: "환불내역" },
    { id: "usageHistory", label: "이용내역" },
  ];

  const getVisibleTabs = () => {
    const allTabs = getAllTabs();

    // 로그아웃 상태: 환불 관련 탭 숨김
    if (!user?.id) {
      return allTabs.filter(
        (tab) => tab.id !== "refundRequest" && tab.id !== "refundHistory"
      );
    }

    // SELLER role: 환불 관련 탭 숨김
    if (user?.role === "SELLER") {
      return allTabs.filter(
        (tab) => tab.id !== "refundRequest" && tab.id !== "refundHistory"
      );
    }

    // AGENCY role 또는 기타 role: 모든 탭 표시
    return allTabs;
  };

  const depositTabs = getVisibleTabs();

  useEffect(() => {
    // 로그아웃 상태이거나 SELLER role이면서 환불 관련 탭이 활성화된 경우
    if (
      (!user?.id || user?.role === "SELLER") &&
      (activeSubTab === "refundRequest" || activeSubTab === "refundHistory")
    ) {
      setActiveSubTab("chargeRequest");
    }
  }, [user?.id, user?.role, activeSubTab]);

  const handleSubTabClick = (tabName) => {
    setActiveSubTab(tabName);
  };

  const renderSubTabContent = () => {
    switch (activeSubTab) {
      case "chargeRequest":
        return <ChargeRequest />;
      case "chargeHistory":
        return <ChargeHistory />;
      case "refundRequest":
        // 로그인 상태이고 SELLER가 아닌 경우에만 환불신청 표시
        return user?.id && user?.role !== "SELLER" ? (
          <RefundRequest />
        ) : (
          <ChargeRequest />
        );
      case "refundHistory":
        // 로그인 상태이고 SELLER가 아닌 경우에만 환불내역 표시
        return user?.id && user?.role !== "SELLER" ? (
          <RefundHistory />
        ) : (
          <ChargeRequest />
        );
      case "usageHistory":
        return <UsageHistory />;
      default:
        return <ChargeRequest />;
    }
  };

  return (
    <div className="deposit-widget-card">
      <div className="deposit-header">
        <h1 className="deposit-page-title">예치금 관리</h1>
      </div>
      <TabNavigation
        className="deposit-segment-tabs"
        tabs={depositTabs}
        activeTab={activeSubTab}
        onTabClick={handleSubTabClick}
      />
      <div className="deposit-content">{renderSubTabContent()}</div>
    </div>
  );
};

export default Deposit;
